<template>
  <a-menu
    style="padding: 5px; border: 0;"
    :selectedKeys="current"
    :openKeys.sync="openKeys"
    mode="inline"
    :inlineCollapsed="collapsed"
  >
    <a-menu-item @click="setView('app')" key="app" title=" Company / Công ty">
      <a-icon type="home" /> Company / Công ty
    </a-menu-item>
    <a-menu-item
      @click="setView('workLeave')"
      key="workLeave"
      title="Leave / Nghỉ phép"
    >
      <a-icon type="carry-out" /> Leave / Nghỉ phép
    </a-menu-item>
    <a-menu-item
      @click="setView('configQLNS')"
      key="configQLNS"
      title="Config HR / Cấu hình Nhân sự"
    >
      <a-icon type="apartment" /> Config HR / Cấu hình Nhân sự
    </a-menu-item>
    <a-menu-item
      @click="setView('employee')"
      key="employee"
      title="Employee / Nhân viên"
    >
      <a-icon type="usergroup-add" /> Employee / Nhân viên
    </a-menu-item>
    <a-menu-item @click="setView('user')" key="user" title="User / Người dùng">
      <a-icon type="usergroup-add" /> User / Người dùng
    </a-menu-item>
    <a-menu-item
      @click="setView('list-permission')"
      key="list-permission"
      title="List permission"
    >
      <a-icon type="usergroup-add" /> List permission
    </a-menu-item>
    <a-menu-item @click="setView('helpdesk')" key="helpdesk">
      <a-icon type="phone" /> Helpdesk
    </a-menu-item>
    <a-menu-item @click="setView('documentType')" key="documentType">
      <a-icon type="file-search" /> Document type
    </a-menu-item>
    <a-menu-item @click="setView('vehicle')" key="vehicle">
      <a-icon type="car" /> Vehicle
    </a-menu-item>
    <a-menu-item @click="setView('reminder')" key="reminder">
      <a-icon type="bell" /> Reminder
    </a-menu-item>
    <a-menu-item
      @click="setView('appInPlatformGroup')"
      key="appInPlatformGroup"
    >
      <a-icon type="bell" /> Group app
    </a-menu-item>
    <!-- <a-menu-item @click="setView('helpdesk')" key="helpdesk">
      <a-icon type="phone" /> Helpdesk
    </a-menu-item>
    <a-menu-item @click="setView('documentConfig')" key="documentConfig">
      <a-icon type="folder-open" /> Document
    </a-menu-item>
     <a-menu-item @click="setView('customer')" key="customer">
      <a-icon type="contacts" /> Customer
    </a-menu-item> -->
    <!-- <a-menu-item
      @click="setView('customer')"
      key="customer"
      title="Customer / Khách hàng"
    >
      <a-icon type="contacts" /> Customer / Khách hàng
    </a-menu-item> -->

    <a-sub-menu key="sub7">
      <span slot="title" :style="styleBorderBot">
        <a-icon type="tags" /><span> Basic Config </span>
      </span>
      <a-menu-item
        v-for="e in menuConfigItems"
        :key="e.id"
        @click="setView(e.id)"
        :title="e.name"
      >
        {{ e.name }}
      </a-menu-item>
    </a-sub-menu>

    <!-- <a-sub-menu key="sub8">
      <span slot="title" :style="styleBorderBot">
        <a-icon type="tags" /><span> Phân Quyền </span>
      </span>
      <a-menu-item
        v-for="e in menuConfigRole"
        :key="e.id"
        @click="setView(e.id)"
      >
        {{ e.name }}
      </a-menu-item>
    </a-sub-menu> -->
  </a-menu>
</template>
<script>
import enumApp from "./constants/enumApp";

const menuConfigItems = [
  { id: "department", name: "Department / Phòng ban" },
  {
    id: "documentAgencyIssued",
    name: "Document Agency Issued / Cơ quan ban hành",
  },
  { id: "holiday", name: "Holiday / Nghỉ lễ" },
  { id: "branchLocation", name: "Location / Địa điểm làm việc" },
  { id: "parcelType", name: "Parcel type / Loại kiện hàng" },
  { id: "position", name: "Position / Chức vụ" },
  { id: "workShift", name: "Shift / Ca làm việc" },
  { id: "vehicleType", name: "Vehicle type / Loại xe" },
  { id: "departmentGroup", name: "Department Group / Nhóm phòng ban" },
];

const menuConfigRole = [
  { id: "role", name: "Vai trò" },
  { id: "permissionAction", name: "Hành động" },
  { id: "permissionPossession", name: "Sở hữu" },
  { id: "module", name: "Mô đun" },
];

export default {
  props: {},
  data() {
    return {
      menuConfigItems,
      menuConfigRole,
      enumApp,
      current: ["ToMe"],
      openKeys: ["sub4", "sub5", "sub6", "sub7"],
      collapsed: false,
      styleBorderBot:
        "border-bottom: 1px solid #e4e9f0; padding-bottom:5px;font-weight:bold",
    };
  },
  methods: {
    handleClick(e) {
      console.log("click", e);
    },
    titleClick(e) {
      console.log("titleClick", e);
    },
    activeDisabled(e) {
      const path = this.$route.path;
      if (path.indexOf(e?.id) > -1) {
        return true;
      }
      return false;
    },
    setDefaulValueSelected() {
      const appName =
        this.$route.meta && this.$route.meta.appName
          ? this.$route.meta.appName
          : "";
      const indexApp = appName ? this.enumApp.indexOf(appName) : -1;
      if (indexApp > -1) {
        this.current = [this.enumApp[indexApp]];
      } else {
        this.current = [];
      }
    },
    goToCauHinh() {
      this.$router.push({ name: "Cấu hình" });
    },
    setView(id) {
      this.$router.push(`/config/${id}`);
    },
  },
  watch: {
    openKeys(val) {
      console.log("openKeys", val);
    },
    $route() {
      this.setDefaulValueSelected();
    },
  },
  created() {
    this.activeDisabled();
    this.setDefaulValueSelected();
  },
};
</script>
<style lang="scss" scoped>
.ant-menu-item {
  height: 30px !important;
  line-height: 30px !important;
  margin-bottom: 0 !important;
  &:hover {
    background-color: #f4f9ff;
  }
}
</style>
